// @flow
import { combineReducers } from 'redux';
import patient from './patientReducer';
import problem from './problemReducer';
import treatment from './treatmentReducer';
import informationHistory from './informationHistoryReducer';
import testing from './testingReducer';
import immunization from './immunizationReducer';
import growthChart from './growthChartReducer';
import wellChildCheck from './wellChildCheckReducer';
import progressNote from './progressNoteReducer';
import externalReports from './externalReportsReducer';
import search from './searchReducer';
import pharmacy from './pharmacyReducer';
import account from './accountReducer';
import monthlyReport from './monthlyReportReducer';

const rootReducer = combineReducers({
  patient,
  problem,
  treatment,
  informationHistory,
  testing,
  immunization,
  growthChart,
  wellChildCheck,
  progressNote,
  externalReports,
  search,
  pharmacy,
  account,
  monthlyReport,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./client/src/reducers/index.js